module.exports = __webpack_public_path__ + "img/sword-earth-05.821c694c.png";